import { notificationTypes } from './types';

const showError = config => {
    return {
        type: notificationTypes.SHOW,
        payload: { ...config, severity: 'error' }
    };
};

const showSuccess = config => {
    return {
        type: notificationTypes.SHOW,
        payload: { ...config, severity: 'success' }
    };
};

const showWarning = config => {
    return {
        type: notificationTypes.SHOW,
        payload: { ...config, severity: 'warning' }
    };
};

const showInfo = config => {
    return {
        type: notificationTypes.SHOW,
        payload: { ...config, severity: 'info' }
    };
};

const hide = () => {
    return {
        type: notificationTypes.HIDE
    };
};

export const notificationActions = {
    showError,
    showSuccess,
    showWarning,
    showInfo,
    hide
};